import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';
import { FC, ReactNode } from 'react';

const client = new ApolloClient({
  uri: theme.storefrontAPIUrl,
  cache: new InMemoryCache(),
  headers: {
    'X-Shopify-Storefront-Access-Token': theme.storefrontAPIKey,
  },
});

export const GraphQLProvider: FC<{ children: ReactNode }> = ({ children }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
